import { EditorStats } from 'components/app/editor/editor-stats/editor-stats';

import styles from './_selector-stats.module.scss';

export const SelectorStats = () => {
  return <EditorStats className={styles.SelectorStats} itemsName="storyboard highlights" />;
};
